import { render } from "./SupportSelector.vue?vue&type=template&id=ece2dba6"
import script from "./SupportSelector.vue?vue&type=script&lang=js"
export * from "./SupportSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__